import React from 'react';
import TimeGrid from 'react-big-calendar/lib/TimeGrid';
import Week from 'react-big-calendar/lib/Week';
import { scheduleMoment } from '../../utils/scheduleTime';

// The stock work-week view filters Date.getDay() in the device's zone. Use the
// schedule's zone for that filter too, keeping the same TimeGrid and UI.
export default function ScheduleWorkWeek({
  date, localizer, enableAutoScroll = true,
  scrollToTime = localizer.startOf(new Date(), 'day'), ...props
}) {
  return <TimeGrid
    {...props}
    localizer={localizer}
    range={ScheduleWorkWeek.range(date, { localizer })}
    eventOffset={15}
    enableAutoScroll={enableAutoScroll}
    scrollToTime={scrollToTime}
  />;
}

ScheduleWorkWeek.defaultProps = TimeGrid.defaultProps;
ScheduleWorkWeek.navigate = Week.navigate;
ScheduleWorkWeek.range = (date, { localizer }) => (
  Week.range(date, { localizer }).filter(day => scheduleMoment(day).isoWeekday() <= 5)
);
ScheduleWorkWeek.title = (date, { localizer }) => {
  const days = ScheduleWorkWeek.range(date, { localizer });
  return localizer.format({ start: days[0], end: days[days.length - 1] }, 'dayRangeHeaderFormat');
};
